// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e73c61ed53664881","5405":"f83ccdcc3b2be9d1"}[chunkId] + ".css";
};